/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewPrivacyData } from './CRSFSecReviewPrivacyData';
import {
    CRSFSecReviewPrivacyDataFromJSON,
    CRSFSecReviewPrivacyDataFromJSONTyped,
    CRSFSecReviewPrivacyDataToJSON,
} from './CRSFSecReviewPrivacyData';

/**
 * 
 * @export
 * @interface CRSFSecReviewPrivacyResultItem
 */
export interface CRSFSecReviewPrivacyResultItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    asset: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    created: number;
    /**
     * 
     * @type {CRSFSecReviewPrivacyData}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    data: CRSFSecReviewPrivacyData;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    domain_origination?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    ext_type?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    found?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyResultItem
     */
    source_asset: string;
}

/**
 * Check if a given object implements the CRSFSecReviewPrivacyResultItem interface.
 */
export function instanceOfCRSFSecReviewPrivacyResultItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "source_asset" in value;

    return isInstance;
}

export function CRSFSecReviewPrivacyResultItemFromJSON(json: any): CRSFSecReviewPrivacyResultItem {
    return CRSFSecReviewPrivacyResultItemFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyResultItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyResultItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'created': json['created'],
        'data': CRSFSecReviewPrivacyDataFromJSON(json['data']),
        'domain_origination': !exists(json, 'domain_origination') ? undefined : json['domain_origination'],
        'ext_type': !exists(json, 'ext_type') ? undefined : json['ext_type'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'process_id': json['process_id'],
        'source_asset': json['source_asset'],
    };
}

export function CRSFSecReviewPrivacyResultItemToJSON(value?: CRSFSecReviewPrivacyResultItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'created': value.created,
        'data': CRSFSecReviewPrivacyDataToJSON(value.data),
        'domain_origination': value.domain_origination,
        'ext_type': value.ext_type,
        'found': value.found,
        'process_id': value.process_id,
        'source_asset': value.source_asset,
    };
}

